import {
  GetWeddingWebsiteDataBody,
  GetWeddingWebsiteDataResponse,
} from '@bridebook/web/pages/api/for/website/[websiteId]';
import { HttpStatusCode } from '@bridebook/toolbox/src/api/http-status';
import { fetchy, FetchyError } from '@bridebook/web/lib/fetchy';

/**
 * Type guard to check if a value is a valid GetWeddingWebsiteDataResponse
 */
const isGetWeddingWebsiteDataResponse = (
  value: unknown,
): value is GetWeddingWebsiteDataResponse => {
  if (typeof value !== 'object' || value === null) {
    return false;
  }

  const response = value as Record<string, unknown>;
  return (
    response.resultCode === 'ok' ||
    response.resultCode === 'pin_missing' ||
    response.resultCode === 'invalid_pin'
  );
};

export const fetchWeddingWebsite: (
  websiteId: string,
  params: {
    pin?: GetWeddingWebsiteDataBody['pin'];
  },
  baseUrl?: string,
) => Promise<{
  data: GetWeddingWebsiteDataResponse;
  httpStatus: number;
}> = async (websiteId, params, baseUrl) => {
  try {
    const response = await fetchy(baseUrl ?? undefined).post(
      '/api/for/website/[websiteId]',
      { websiteId },
      params,
    );

    return {
      data: response,
      httpStatus: HttpStatusCode.OK,
    };
  } catch (error) {
    const fetchyError = error as FetchyError;
    const errorBody = fetchyError.body;

    // Check if the error body is a valid GetWeddingWebsiteDataResponse (e.g., 401 with password page data)
    if (isGetWeddingWebsiteDataResponse(errorBody)) {
      return {
        data: errorBody,
        httpStatus: fetchyError.code ?? HttpStatusCode.InternalServerError,
      };
    }

    throw error;
  }
};
